import { rgba, transparentize } from 'polished'
import styled, { StyledProps } from 'styled-components'

interface RootProps {
  disabled?: boolean
}

const labelColor = (props: StyledProps<RootProps>): string => rgba(props.theme.colors.text, 0.5)

const brandColor = (props: StyledProps<RootProps>): string =>
  props.disabled ? transparentize(0.3, props.theme.colors.brandA500) : props.theme.colors.brandA500

const Root = styled.span<RootProps>`
  /* Border */
  &::before {
    border-color: ${(props) => props.theme.colors.border};
  }

  /* Small label, the floating one */
  > .floatingLabelInputLabel {
    color: ${brandColor};
  }
  /* Big label, the one that sits in the input until focussed */
  &:focus-within > .floatingLabelInputLabel {
    color: ${brandColor};
  }
  & > input:placeholder-shown:not(:focus) ~ .floatingLabelInputLabel,
  textarea:placeholder-shown:not(:focus) ~ .floatingLabelInputLabel {
    color: ${(props) => labelColor(props)};
  }
  & > input::placeholder,
  textarea::placeholder {
    color: ${(props) => labelColor(props)};
  }
  &:focus-within::before {
    border-color: ${brandColor};
  }

  > .floatingLabelInputPrefix,
  > .floatingLabelInputSuffix {
    color: ${(props) => labelColor(props)};
  }
  &:focus-within > .floatingLabelInputPrefix,
  &:focus-within > .floatingLabelInputSuffix {
    color: ${brandColor};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    border: 2px solid ${brandColor} !important;
    border-radius: 6px !important;
    box-shadow: 0 0 0px 1000px white inset;
    transition: background-color 5000s ease-in-out 0s;
    z-index: 2 !important;
  }
`

export default Root
